import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { addMall, getMallById, updateMall } from 'app/api/mall';
import { uplaodMedia } from 'app/api/store';
import {
  mallValidationRules,
  validate,
} from 'app/constants/validation-constants';
import Message from 'app/utils/Message';
import {
  convertTo12HourFormat,
  convertTo24HourFormat,
} from 'app/utils/Parsers';
import Toast from 'app/utils/Toast';
import { LocalStorage } from 'app/utils/storage';
import { LocalSessionKey } from 'app/constants/app-constants';
const useCreateMall = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [pageLoading, setPageLoading] = useState(false);

  const [error, setErrors] = useState({});
  const [values, setValues] = useState({
    mallName: '',
    description: '',
    address: '',
    city: '',
    location: '',
    contact_number: '',
    opening_time: '10:00',
    closing_time: '17:00',
    logo: null,
    status: true,
  });

  const mall_id = location?.state?.id ? location?.state?.id : '';

  useEffect(() => {
    if (mall_id) {
      loadStoreData(mall_id);
    }
  }, [mall_id]);

  async function loadStoreData(id) {
    if (!id) {
      return;
    }

    setPageLoading(true);
    let response = await getMallById(id);
    setPageLoading(false);
    if (response?.responseCode === 200) {
      let responsedata = response?.data[0];

      setValues({
        description: responsedata?.description,
        logo: responsedata?.logo,
        mallName: responsedata?.name,
        opening_time:
          responsedata?.openingTime &&
          convertTo24HourFormat(responsedata?.openingTime),
        closing_time:
          responsedata?.closingTime &&
          convertTo24HourFormat(responsedata?.closingTime),
        contact_number: responsedata?.phoneNumber,
        location: responsedata?.location,
        city: responsedata?.city,
        address: responsedata?.address,
        status: responsedata?.status,
      });
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message?.Error?.COMMON_MESSAGE
      );
    }
  }

  async function callAddOrUpdateAPI() {
    setPageLoading(true);
    let response = {};

    let senddata = {
      ...values,
      name: values.mallName,
      opening_time: convertTo12HourFormat(values.opening_time),
      closing_time: convertTo12HourFormat(values.closing_time),
    };

    if (mall_id) {
      response = await updateMall(mall_id, { ...senddata });
    } else {
      response = await addMall({ ...senddata });
    }
    setPageLoading(false);

    if (response?.responseCode === 200) {
      Toast.success(
        mall_id ? Message.Mall.UPDATED_SUCCESS : Message.Mall.CREATED_SUCCESS
      );

      if (!mall_id) addValueinDropdownHeader(response?.data);
      navigate(-1);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message?.Error?.COMMON_MESSAGE
      );
    }
  }

  function handleCreateMall(e) {
    e.preventDefault();
    const validationErrors = validate(values, mallValidationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      callAddOrUpdateAPI();
    }
  }

  function handleTime(value, name) {
    setValues((prevValues) => {
      const newValues = { ...prevValues, [name]: value };

      if (
        name === 'opening_time' &&
        newValues.closing_time &&
        new Date(`1970-01-01T${newValues.closing_time}`) <=
          new Date(`1970-01-01T${value}`)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          closing_time: 'Closing time must be after opening time.',
        }));
      } else if (
        name === 'closing_time' &&
        newValues.opening_time &&
        new Date(`1970-01-01T${value}`) <=
          new Date(`1970-01-01T${newValues.opening_time}`)
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          closing_time: 'Closing time must be after opening time.',
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          closing_time: '',
        }));
      }

      return newValues;
    });
    if (error[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: '',
      }));
    }
  }

  function handleChange(e) {
    if (e && e.target) {
      const { name, value } = e.target;
      setValues({
        ...values,
        [name]: value,
      });

      if (error[name]) {
        setErrors({
          ...error,
          [name]: '',
        });
      }
    }
  }

  function setChange(name, val) {
    setValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
    setErrors({
      ...error,
      [name]: '',
    });
  }

  async function uploadMediaHandler(file, name) {
    if (!file) {
      // If the file is null, it means the user clicked the remove button
      setChange(name, null);
      return;
    }

    const response = await uplaodMedia(file);
    if (response.responseCode === 200) {
      Toast.success('Image upload Successfull');

      const data = await response.data;
      setChange(name, data?.url);
    } else {
      Toast.error('Image upload failed');
    }
  }
  function addValueinDropdownHeader(value) {
    const tempuserMallListResponse = JSON.parse(
      LocalStorage.get(LocalSessionKey.MALL_LIST)
    );
    const { mall_List: mallArray, mallId: idArray } = tempuserMallListResponse;
    mallArray.push(value);
    idArray.push(value?.id);
    LocalStorage.set(LocalSessionKey.RELOAD_MALL, true);
    LocalStorage.set(
      LocalSessionKey.MALL_LIST,
      JSON.stringify({
        ...tempuserMallListResponse,
        mall_List: mallArray,
        mallId: idArray,
      })
    );
    const joinedString = idArray.join(',');
    LocalStorage.set(LocalSessionKey.MALL_ID, joinedString);
  }
  return {
    handleChange,
    values,
    error,
    handleCreateMall,
    pageLoading,
    uploadMediaHandler,
    setChange,
    mall_id,
    handleTime,
    navigate,
  };
};

export default useCreateMall;
